import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import DataTable from 'react-data-table-component';
import backendURL from "../../config";
import Drawer from "@mui/material/Drawer";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';


// Define the Expandable Component
const ExpandedRow = ({ data }) => {
  return (
    <div style={{ padding: '10px 20px' }}>
      <h5>Exception Log Details for {data.error_code}</h5>
      <p><strong>Exception Log Message:</strong> {data.message}</p>
    </div>
  );
};


export default function ListExceptionLog() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const fetchedUrl = queryParams.get('fetched_url');

  

  const [exceptionLogs, setExceptionLogs] = useState([]);
  const [filteredExceptionLogs, setFilteredExceptionLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [reload, setReload] = useState(false);

  // Function to toggle the reload state
  const handleReload = () => {
    setReload(!reload); 
  };

  useEffect(() => {
    exceptionLogs.title = "Audio & Language Settings | KlonIT Web Application";
    fetchExceptionLogs();
  }, [reload]);

  // Function to fetch exceptionLogs from the API
  const fetchExceptionLogs = useCallback(async () => {
      try {
          const token = localStorage.getItem("access_token");
          const headers = {
              Authorization: `Bearer ${token}`,
          };

          const response = await axios.get(`${backendURL}/get-exception-log`, { headers });

          const responseData = typeof response.data.data === 'string' ? JSON.parse(response.data.data) : response.data.data;

          setExceptionLogs(responseData);
          setFilteredExceptionLogs(responseData); // Initialize filtered data
          setLoading(false);
      } catch (error) {
          setError(error.response.data.message);
          setLoading(false);
      }
  }, []); // Add fetchExceptionLogs as a dependency

  const handleSearch = (event) => {
    const value = event.target.value.toLowerCase();
    setSearchTerm(value);
    const filtered = exceptionLogs.filter(
      (doc) =>
        (doc.error_code?.toString() ?? '').includes(value) ||
        doc.log_type.toLowerCase().includes(value) ||
        doc.status.toLowerCase().includes(value) ||
        doc.created_on.toLowerCase().includes(value) ||
        doc.updated_on.toLowerCase().includes(value)
    );
    setFilteredExceptionLogs(filtered);
  };

  const columns = [
    {
      name: "Exception Log Reference ID",
      selector: (row) => row.error_code,
      sortable: true,
    },
    {
      name: "Exception Log Type",
      selector: (row) => row.log_type,
      sortable: true,
    },
    {
      name: "Exception Log Status",
      selector: (row) => row.status,
      sortable: true,
    },
    {
      name: "Exception Log Created On",
      selector: (row) => row.created_on,
      sortable: true,
    },
    {
      name: "Exception Log Updated On",
      selector: (row) => row.updated_on,
      sortable: true,
    }
  ];

  const toggleDrawer = (open) => {
    setIsDrawerOpen(open);
  };

  

  return (
    <div className="row">
      <div className="col-12 col-lg-12 col-xxl-12 d-flex">
        <div className="card flex-fill">
          <div className="card-header">
            <div className="row">
              <div className="col-lg-4">
                <h5 className="card-title mb-1">Exception Logs</h5>
              </div>
              <div className="col-lg-4">
              </div>
              <div className="col-lg-4 text-right">
                <input
                  type="text"
                  placeholder="Search data..."
                  className="form-control mb-3"
                  value={searchTerm}
                  onChange={handleSearch}
                />
              </div>
            </div>
          </div>
          <div className="card-body">
            {loading ? (
              <p>Loading...</p>
            ) : filteredExceptionLogs.length === 0 ? (
              <p>No data available</p>
            ) : (
              <DataTable
                columns={columns}
                data={filteredExceptionLogs}
                pagination
                highlightOnHover
                pointerOnHover
                expandableRows
                expandOnRowClicked
                expandableRowsComponent={({ data }) => <ExpandedRow data={data} />}
              />
            )}
            <br />
            <div id="getError" className={`alert alert-warning ${error ? "" : "d-none"}`}>
              {error}
            </div>
            <br />
          </div>
        </div>
      </div>
      <Drawer
        anchor="right"
        open={isDrawerOpen}
        onClose={() => toggleDrawer(false)}
        PaperProps={{ style: { width: "500px" } }}
      >
        <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '8px' }}>
          <IconButton onClick={() => toggleDrawer(false)}>
            <CloseIcon />
          </IconButton>
        </div>
      </Drawer>
    </div>
  );
}